import { Link, Outlet } from "react-router-dom";

import { AppHeader } from "@vellum/ui";

export function RootLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <AppHeader
        brand="Reporting"
        accent="teal"
        navItems={[{ label: "Reports", href: "/" }]}
        renderLink={({ href, className, children }) => (
          <Link to={href} className={className}>
            {children}
          </Link>
        )}
        showLogo
      />
      {/* Full-bleed and height-filling on purpose: a report embed is a wide
          data table that gets clipped inside a reading-width column. Pages
          that do want that column wrap themselves in `PageContainer`. */}
      <main className="flex min-h-0 w-full flex-1 flex-col">
        <Outlet />
      </main>
    </div>
  );
}
